module.exports = __webpack_public_path__ + "media/images/icons/filled/folder-open-6e40b4c2035e09607a77228a7ab718a2.svg";